export const BASE_PAGE = '/';
export const LOGIN_PAGE = '/login';
export const ADMIN_PAGE = '/settings';
export const DASHBOARD = '/';
